<script>
  import { computedPbxPlans } from '@/common/service/computers/plans/pbx';
  import {
    PBX_REGIONS_MAP_COUNTRY, PBX_REGIONS, PBX_GS
  } from '@/plans/ZOOM_PHONE/helper/constants';
  import configUK from './config-UK.vue';
  import configUS from './config-US.vue';
  import configJP from './config-JP.vue';
  import configGS from './config-GS.vue';
  import { mapGetters } from 'vuex';
  import { findKey } from '@/plans/ZOOM_PHONE/helper/utils';

  export default {
    components:{
      configUK,
      configUS,
      configJP,
      configGS
    },
    props: {
      configPlanTileStatus: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapGetters({
        'getSelectedPlans': 'getSelectedPlans',
      }),
      selectedPbxPlans() {
        return computedPbxPlans(this.getSelectedPlans);
      },
      selectedRegion() {
        return findKey(PBX_REGIONS_MAP_COUNTRY,this.selectedPbxPlans.filter(item => item.region)[0]?.region)
      },
      isGlobalSelect(){
        return this.selectedPbxPlans.some(item => PBX_GS.includes(item.category)) && this.$config('enableZoomPhoneGlobalSelect')
      },
      enableJPBuy(){
        return this.$config('enableZPJapanOnlineBuy');
      }
    },
    methods:{
      renderRegions(){
        const propsContext = { configPlanTileStatus: this.configPlanTileStatus };
        if(this.isGlobalSelect && !this.$context.is.add2cart){
          return <configGS {...{ props: { ...this.$attrs ,...propsContext}, on: { ...this.$listeners }}} />;
        }
        // for add2cart, reuse this module to config 3 regions at one time
        if(this.$context.is.add2cart) {
          const selectedRegion = [
            PBX_REGIONS.US_AND_CANADA,
            PBX_REGIONS.UK_AND_IRELAND,
            PBX_REGIONS.AUS_AND_NZ,
          ].includes(this.selectedRegion) && this.selectedRegion || PBX_REGIONS.US_AND_CANADA;
          return <configUK region={selectedRegion} {...{ props: { ...this.$attrs,...propsContext }, on: { ...this.$listeners }}} />;
        };
        switch (this.selectedRegion) {
          case PBX_REGIONS.JP:
            if(this.enableJPBuy  || this.$context.is.edit){
              return <configJP region={PBX_REGIONS.JP} {...{ props: { ...this.$attrs,...propsContext }, on: { ...this.$listeners }}} />;
            };
            return <configUS {...{ props: { ...propsContext } }}/>
          case PBX_REGIONS.UK_AND_IRELAND:
          return <configUK region={PBX_REGIONS.UK_AND_IRELAND} {...{ props: { ...this.$attrs,...propsContext }, on: { ...this.$listeners }}} />;
          case PBX_REGIONS.AUS_AND_NZ:
          return <configUK region={PBX_REGIONS.AUS_AND_NZ} {...{ props: { ...this.$attrs,...propsContext }, on: { ...this.$listeners }}} />;
          case PBX_REGIONS.US_AND_CANADA:
          return <configUS {...{ props: { ...this.$attrs ,...propsContext}, on: { ...this.$listeners }}} />
          default:
            return <configUS {...{ props: { ...propsContext } }}/>
        }
      }
    },
    render() {
      return this.renderRegions()
    }
  }
</script>
